<p-toast></p-toast>

<div class="email-signature">
  <h2 class="title">Assinatura de e-mail</h2>

  <div class="email-signature__content">
    <!-- Formulário -->
    <div class="email-signature__form">
      <div class="card">
        <h3>Dados da assinatura</h3>
        <form class="form-b4a" [formGroup]="formGroup" (submit)="copySignature()">

        <span class="p-float-label">
          <input pInputText id="nome" formControlName="nome" />
          <label for="nome">Nome</label>
        </span>

        <span class="p-float-label">
          <input pInputText id="cargo" formControlName="cargo" />
          <label for="cargo">Cargo</label>
        </span>

        <span class="p-float-label">
          <input pInputText id="email" formControlName="email" type="email" />
          <label for="email">E-mail</label>
        </span>

        <span class="p-float-label">
          <p-inputMask id="telefone" formControlName="telefone" mask="(99)9 9999-9999"></p-inputMask>
          <label for="telefone">Telefone</label>
        </span>

        <div class="full-w">
          <label class="field__label">Cor do tema</label>
          <p-selectButton
            [options]="colorOptions"
            formControlName="selectedColor"
            optionLabel="label"
            optionValue="value"
          ></p-selectButton>
        </div>

        <div class="buttons">
          <button
            pButton
            type="submit"
            label="Copiar Assinatura"
            icon="pi pi-copy"
            class="p-button-primary"
          ></button>
        </div>
        </form>
      </div>
    </div>

    <!-- Pré-visualização -->
    <div class="email-signature__preview">
      <div class="card">
        <h3>Pré-visualização</h3>
        <div class="email-signature__preview-box" [innerHTML]="signatureHtml"></div>
      </div>
    </div>
  </div>
</div>
